import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import Modal from '../Modal';
import Cart from '../screens/Cart';
import { useCart } from './ContextReducer';
import { XLg } from 'react-bootstrap-icons'

export default function Header() {
    const data = useCart();
    const [cartView, setCartView] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false);
    const navigate = useNavigate();


    const toggleButton = () => {
        setIsExpanded(!isExpanded);
    };


    const handlelogout = () => {
        localStorage.removeItem("authToken");
        navigate("/login")
    }


    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-success">
                <div className="container-fluid">
                    <Link className="navbar-brand fs-1" to="/">GoFood</Link>
                    <button className="navbar-toggler" onClick={toggleButton} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            {isExpanded ? <span><XLg/></span> : <span className="navbar-toggler-icon"></span>}
                        </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                            </li>
                            {(localStorage.getItem("authToken")) ?
                                <li className="nav-item">
                                    <Link className="nav-link active" aria-current="page" to="/MyOrder">My Order</Link>
                                </li>
                                : ""}
                        </ul>
                        {(!localStorage.getItem("authToken")) ?
                            <div className='d-flex'>
                                <Link className="btn bg-white text-success mx-1 " to="/Login">Login</Link>
                                <Link className="btn bg-white text-success mx-1" to="/Signup">Signup</Link>
                            </div>
                            : <div>
                                <div className="btn bg-white text-success mx-1" onClick={() => { setCartView(true) }}>
                                    My Cart <Badge pill bg="success">{data.length}</Badge>
                                </div>
                                {cartView ? <Modal onClose={() => setCartView(false)}><Cart></Cart></Modal> : ""}
                                <div className="btn bg-white text-danger mx-1" onClick={handlelogout}>
                                    Logout
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </nav>
        </>
    )
}
